import { useEffect, useContext, useState } from "react";
import {Subscription} from "../queries/subscription";
import {SubscriptionContext} from "../state/subscriptionContext";
import {useAuthentication} from "../../auth/hooks/useAuthentication";

const useSubscription = () => {
    const {state, dispatch} = useContext(SubscriptionContext);
    const {isLoading} = useAuthentication();

    useEffect(() => {
        !isLoading && state.length === 0 && Subscription.getSubscriptionList().then((response) => {
            console.log(response)
            dispatch({ type: "initSubscriptionList", payload: response });
        });
    }, [isLoading])

    const findById = async (id) => {
        return await Subscription.findById(id);
    }

    const saveSubscription = (sessionId) => {
        Subscription.saveSubscription(sessionId)
    }

    return {subscriptionList : state, findById, saveSubscription}
}

export {useSubscription}
